module.exports = __webpack_public_path__ + "media/images/lp/history2-sp-f8f2e7e9611207fb7478af5654b09161.jpg";